module.exports = __webpack_public_path__ + "5f048251a5e5b39e8d7b95f98e4a50ba.png";